import React from "react";
import "./Home.css";
import irbLogo from "./irb.png";
import kecLogo from "./kec.png";
import vedantaLogo from "./vedanta.png";
import eagleLogo from "./eagle.png";
import kalpaturuLogo from "./kalpataru.jpg";
import listenlightLogo from "./listenlight.png";
import gajraLogo from "./gajra.png";

const logos = [
  { src: irbLogo, alt: "IRB Logo" },
  { src: kecLogo, alt: "KEC Logo" },
  { src: vedantaLogo, alt: "Vedanta Logo" },
  { src: eagleLogo, alt: "Eagle Logo" },
  { src: kalpaturuLogo, alt: "Kalpataru Logo" },
  { src: listenlightLogo, alt: "Listenlight Logo" },
  { src: gajraLogo, alt: "Gajra Logo" },
];

const LogoGrid: React.FC = () => {
  return (
    <div className="logo-inline-container">
      {logos.map((logo, index) => (
        <img
          key={index}
          src={logo.src}
          alt={logo.alt}
          className="logo-inline-image"
        />
      ))}
    </div>
  );
};

export default LogoGrid;
